import styled from 'styled-components';

import { Button } from '@calm-web/design-system';

export const EmotionGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 8px;
	justify-content: center;
`;

export const TitleContainer = styled.div`
	text-align: center;
	margin-bottom: 20px;
`;

export const StyledButton = styled(Button).attrs({
	backgroundColor: 'accessibleBrandGradient' as const,
})`
	min-width: 160px;
`;

export const ConfirmQuestion = styled.div`
	text-align: center;
	margin-bottom: 20px;
	font-size: 1.1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
`;

export const EmotionDisplay = styled.span`
	font-size: 1.2rem;
	font-weight: 600;
	display: flex;
	align-items: center;
	gap: 6px;
`;

export const ConfirmButton = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 20px;
`;

export const OrPickText = styled.div`
	text-align: center;
	margin-bottom: 20px;
`;

export const EmotionButton = styled.button<{ selected?: boolean }>`
	padding: 12px 24px;
	border: 2px solid ${props => (props.selected ? '#1877f2' : '#e5e7eb')};
	border-radius: 12px;
	background: ${props => (props.selected ? '#1877f2' : '#fff')};
	color: ${props => (props.selected ? '#fff' : '#333')};
	cursor: pointer;
	transition: all 0.2s ease;
	font-size: 14px;
	font-weight: 500;
	text-align: center;
	min-width: 120px;

	&:hover {
		border-color: #1877f2;
		background: ${props => (props.selected ? '#1877f2' : '#f8faff')};
	}

	&:active {
		transform: translateY(1px);
	}

	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
`;
